// extracted by mini-css-extract-plugin
export const header = "bq_bV";
export const headerContainer = "bq_cX";
export const headerBar = "bq_cY";
export const headerTitle = "bq_cZ";
export const lampContainer = "bq_c0";
export const lamp = "bq_c1";
export const lampIcon = "bq_c2";
export const lampTail = "bq_c3";
export const moving = "bq_c4";